/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Mobility_TrainingInputs */

const en_service_type_mobility_training = /** @type {(inputs: Service_Type_Mobility_TrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobility and stretching`)
};

const pl_service_type_mobility_training = /** @type {(inputs: Service_Type_Mobility_TrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobilność i stretching`)
};

/**
* | output |
* | --- |
* | "Mobility and stretching" |
*
* @param {Service_Type_Mobility_TrainingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_mobility_training = /** @type {((inputs?: Service_Type_Mobility_TrainingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Mobility_TrainingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_mobility_training(inputs)
	return en_service_type_mobility_training(inputs)
});